var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useMemo } from 'react';
import { AdminLayout } from 'src/Layouts';
import TicketsTable from 'src/Components/TicketsTable';
import FilterDropdown from 'src/Components/FilterDropdown';
import SearchInput from 'src/Components/SearchInput';
import CreateTicketButton from 'src/Components/Tickets/CreateTicketButton';
import { Title, Container, TableContainer, HeaderContainer, HeaderTitle, ControlsContainer, } from './styles';
import usePersonalInfo from 'src/Views/PersonalInfo/usePersonalInfo';
import { NAME_KEY, LAST_NAME_KEY } from 'src/Utils/constants';
import { useTicketFilters } from './hooks/useTicketFilters';
import { useTicketsWithFilters } from './hooks/useTicketsWithFilters';
import { useDebounce } from 'src/Utils/hooks/useDebounce';
import { useHistory } from 'react-router-dom';
import { useSearchParams } from 'src/Utils/hooks/useSearchParams';
import { getSearchParams } from 'src/Utils/getQueryParams';
var buildFiltersFromSearchParams = function (searchParams) {
    var _a;
    var ticketNumber = (_a = searchParams.get('ticket_number')) !== null && _a !== void 0 ? _a : '';
    var buildingId = searchParams.get('building_id');
    var adminId = searchParams.get('assignee_id');
    var status = searchParams.get('status');
    var ui = {
        ticketSearch: ticketNumber,
        filterValues: {
            building: buildingId ? Number(buildingId) : null,
            admin: adminId ? Number(adminId) : null,
            status: status,
        },
    };
    var api = __assign(__assign(__assign(__assign({}, (ticketNumber ? { ticket_number: ticketNumber } : {})), (buildingId ? { building_id: Number(buildingId) } : {})), (adminId ? { assignee_id: Number(adminId) } : {})), (status ? { status: status } : {}));
    return { ui: ui, api: api };
};
var TicketsPage = function () {
    var history = useHistory();
    var searchParams = useSearchParams();
    var _a = buildFiltersFromSearchParams(searchParams), ui = _a.ui, api = _a.api;
    var userProfile = usePersonalInfo().data;
    var _b = useState(ui.ticketSearch), ticketSearch = _b[0], setTicketSearch = _b[1];
    var _c = useState(ui.filterValues), filterValues = _c[0], setFilterValues = _c[1];
    var _d = useTicketFilters(), buildings = _d.buildings, admins = _d.admins, statusOptions = _d.statusOptions;
    var _e = useTicketsWithFilters(api), tickets = _e.tickets, loading = _e.loading, error = _e.error, totalPages = _e.totalPages, currentPage = _e.currentPage, setPage = _e.setPage, setFilters = _e.setFilters;
    var debouncedSearch = useDebounce(ticketSearch, 500);
    var apiFilters = useMemo(function () {
        var filters = {};
        if (debouncedSearch) {
            filters.ticket_number = debouncedSearch;
        }
        if (filterValues.building) {
            filters.building_id = filterValues.building;
        }
        if (filterValues.admin) {
            filters.assignee_id = filterValues.admin;
        }
        if (filterValues.status) {
            filters.status = filterValues.status;
        }
        return filters;
    }, [
        debouncedSearch,
        filterValues.building,
        filterValues.admin,
        filterValues.status,
    ]);
    useEffect(function () {
        setFilters(apiFilters);
    }, [apiFilters, setFilters]);
    useEffect(function () {
        var search = getSearchParams({
            ticket_number: debouncedSearch || null,
            building_id: filterValues.building,
            assignee_id: filterValues.admin,
            status: filterValues.status,
        });
        history.replace({
            search: search,
        });
    }, [
        debouncedSearch,
        filterValues.building,
        filterValues.admin,
        filterValues.status,
        history,
    ]);
    var handleFilterChange = function (filterType, value) {
        setFilterValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[filterType] = value, _a)));
        });
    };
    var filterConfigs = [
        {
            key: 'building',
            label: 'Edificio',
            placeholder: 'Selecciona edificio',
            options: buildings.map(function (building) { return ({
                value: building.id,
                label: building.name,
            }); }),
            clearable: true,
            width: 210,
        },
        {
            key: 'admin',
            label: 'Administradores',
            placeholder: 'Selecciona admin',
            options: admins.map(function (admin) { return ({
                value: admin.id,
                label: admin.first_name + " " + admin.last_name,
            }); }),
            clearable: true,
            width: 190,
        },
        {
            key: 'status',
            label: 'Estado',
            placeholder: 'Selecciona estado',
            options: statusOptions,
            clearable: true,
            width: 185,
        },
    ];
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null,
                "Bienvenido,",
                ' ',
                userProfile
                    ? userProfile[NAME_KEY] + " " + userProfile[LAST_NAME_KEY]
                    : ''),
            React.createElement(TableContainer, null,
                React.createElement(HeaderContainer, null,
                    React.createElement(HeaderTitle, null, "Lista de Tickets"),
                    React.createElement(ControlsContainer, null,
                        React.createElement(SearchInput, { label: "# Ticket", placeholder: "Buscar # de ticket", value: ticketSearch, onChange: setTicketSearch }),
                        filterConfigs.map(function (config) { return (React.createElement("div", { key: config.key, style: { width: config.width } },
                            React.createElement(FilterDropdown, { label: config.label, placeholder: config.placeholder, options: config.options, value: filterValues[config.key], onChange: function (value) { return handleFilterChange(config.key, value); }, clearable: config.clearable }))); }),
                        React.createElement(CreateTicketButton, { buildingId: filterValues.building }))),
                React.createElement(TicketsTable, { tickets: tickets, loading: loading, error: error, totalPages: totalPages, currentPage: currentPage, onPageChange: setPage })))));
};
export default TicketsPage;
